import { f7 } from 'framework7-react';
import { useCallback, useMemo } from 'react';
import { CheckInReserveDataType } from '../../../types/bodyAndPaint';
import { CheckInReserveDate } from './calendarEntry/checkInReserveDate';
import { useCheckInReserveDateState } from './hook/state/useCheckInReserveDateState';
import { useStorageItem } from './hook/useStorageItem';
import { PageTemplateComponent } from './util/common/pageTemplate/pageTemplate';
import { paths } from '@/config/paths';

export const CheckInReserveDatePage = () => {
  const { stored: checkInEntries, setStorageItem: setCheckInEntries } =
    useStorageItem<CheckInReserveDataType>({ key: 'checkInReserve' });

  const checkInReserveDateStateProps = useMemo(() => {
    return {
      initialReserve: new Date(checkInEntries?.checkInDateInfo ?? 'initial'),
      plantName: checkInEntries?.reserveInfo?.factoryName ?? '',
      affiliateID: checkInEntries?.reserveInfo?.ids?.affiliateID ?? 0,
    };
  }, [checkInEntries]);

  const { plantInfo, reserveDate, calendarInfo, disabled } =
    useCheckInReserveDateState(checkInReserveDateStateProps);
  const handleClickBack = () => {
    f7.views.main.router.navigate(paths.bpsCheckInUseInsurance);
  };
  const handleClickNext = useCallback(() => {
    setCheckInEntries((prev) => ({
      ...prev,
      checkInDateInfo: reserveDate,
      reserveInfo: {
        ...prev.reserveInfo,
        ids: {
          ...prev.reserveInfo.ids,
          plantID: plantInfo.state.id ?? 0,
        },
        factoryName: plantInfo?.state?.name ?? '',
        factoryMapAddress: plantInfo?.state?.address ?? '',
        factoryPhoneNumber: plantInfo?.state?.phone ?? '',
      },
    }));
    f7.views.main.router.navigate(paths.bpsCheckInUseLoanerCar);
  }, [reserveDate, setCheckInEntries]);

  return (
    <PageTemplateComponent
      pageName={'checkInReserve'}
      title={'傷・凹み修理予約'}
      onBack={handleClickBack}
    >
      <CheckInReserveDate
        calendarInfo={calendarInfo}
        disabled={disabled}
        onNext={handleClickNext}
        plantInfo={plantInfo}
      />
    </PageTemplateComponent>
  );
};
